import { datadogRum } from '@datadog/browser-rum'

export default defineNuxtPlugin((nuxtApp) => {
  const { ddApplicationId, ddClientToken, ddEnv, ddVersion } = nuxtApp.$config.public

  datadogRum.init({
    applicationId: ddApplicationId,
    clientToken: ddClientToken,
    site: 'datadoghq.eu',
    service: 'hybrasil',
    env: ddEnv,
    version: ddVersion,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: 'mask-user-input',
    trackingConsent: 'not-granted', // nothing is collected until a user logs in
    trackViewsManually: true,       // we name views ourselves (below)
  })

  // Readable view names: use the Nuxt route name instead of the raw URL
  const router = useRouter()
  router.afterEach((to, from) => {
    if (to.path !== from?.path) {
      datadogRum.startView({ name: String(to.name ?? to.path) })
    }
  })
  // datadogRum.startSessionReplayRecording()
})
